import localizedDayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/fr'

export const PLANNING_TIME_ZONE = 'Europe/Paris'

// allow dayjs to parse custom date formats
localizedDayjs.extend(customParseFormat)
localizedDayjs.extend(utc)
localizedDayjs.extend(timezone)
localizedDayjs.tz.setDefault(PLANNING_TIME_ZONE)
localizedDayjs.locale('fr')

export default localizedDayjs
